/**
 * Course-related constants shared between client and server
 * TODO: This should be moved to the CMS or calculated periodically from real data
 * Last updated: July 8, 2025
 * Moved from client/js/constants/courses.js to here on Jun 29, 2025
 */

const CourseVisits = {
  algorithms: 4149,
  'amazon-interview': 13379,
  'amazon-leadership-principles': 24941,
  'amazon-pm-overview': 5788,
  'amazon-sde-interview': 4639,
  'amazon-sdm-interview': 2827,
  'amazon-solution-architect-interview': 1628,
  analytical: 36375,
  'analytical-problem-solving': 192,
  'app-critique': 2637,
  'aws-sa-intro': 1477,
  behavioral: 14183,
  'behavioral-bizops': 1530,
  'behavioral-interviews-for-pms': 11017,
  bizops: 4504,
  'bizops-data': 2727,
  'bizops-intro': 3748,
  'break-into-fintech': 1015,
  'common-pmm': 5168,
  'conduct-uer': 1872,
  'cross-functional-pmm': 2709,
  'cross-functional-tpm': 12234,
  'data-analytics': 1049,
  'data-analytics-behavioral': 115,
  'data-analytics-introduction': 847,
  'data-analytics-take-home-case-studies': 77,
  'data-analytics-technical': 509,
  'data-communications-questions': 1267,
  'data-engineering': 3650,
  'data-engineering-intro': 2831,
  'data-modeling-interviews': 2264,
  'data-pipeline-design-interviews': 1388,
  'data-science': 5345,
  'data-science-interview': 695,
  'data-scientist-introduction': 4157,
  'design-challenges': 1365,
  'design-run-experiments': 3198,
  'dynamic-programming': 41,
  'em-intro': 16409,
  'eng-behavioral': 0,
  'engineering-management': 19424,
  estimation: 37942,
  execution: 22637,
  'facebook-pm-interview': 7638,
  'facebook-pm-overview': 6102,
  'favorite-product': 17234,
  'fundamentals-analytics': 6977,
  'general-interview': 30389,
  'get-the-interview': 22468,
  'google-collaboration': 3038,
  'google-craft-execution': 3031,
  'google-pm-interview': 13065,
  'google-pm-overview': 8998,
  hidden: 8,
  'introduction-to-security-engineering': 581,
  'machine-learning': 482,
  'marketing-case': 2672,
  'marketing-strategy': 3871,
  'ml-coding': 1397,
  'ml-coding-data-scientist-questions': 934,
  'ml-concepts-interviews': 2563,
  'ml-concepts-questions-data-scientists': 972,
  'ml-engineer': 9443,
  'ml-engineer-intro': 7522,
  'ml-system-design': 6394,
  'people-management': 13821,
  pm: 58113,
  'pm-intro': 53120,
  'pm-product-design': 35561,
  'pm-skills': 5922,
  'pm-technical': 16651,
  pmm: 3936,
  'portfolio-review': 2125,
  'product-designer-interview': 4859,
  'product-designer-intro': 3874,
  'product-sense-case-studies-questions': 131,
  'product-strategy': 29940,
  'program-sense': 8973,
  'project-mgmt-bizops': 1849,
  'project-retro': 7855,
  'python-array-practice': 428,
  'python-coding-data-scientist-questions': 1020,
  'python-data-and-machine-learning': 83,
  'python-developer-interviews': 40,
  'python-graphs-and-trees-practice': 54,
  'python-linked-list-practice': 227,
  'python-ml-system-design': 790,
  'python-string-practice': 27,
  'recursion-and-backtracking': 30,
  'sa-customer-interaction': 1711,
  'sa-intro': 4588,
  'sa-technical': 1817,
  'security-engineering-interviews': 909,
  'security-engineering-mock-interviews': 182,
  'security-principles': 254,
  'software-engineering': 41718,
  'solution-architect-interview': 5512,
  'solutions-architect-behavioral': 1560,
  'sql-interviews': 6231,
  'stakeholder-management-bizops': 2327,
  'statistics-experimentation-questions': 2923,
  'strategic-decisions-bizops': 2373,
  'swe-behavioral': 10987,
  'swe-intro': 20645,
  'swe-practice': 23213,
  'system-design-interviews': 29982,
  'take-home': 10484,
  'tech-salary-offer-negotiation': 1540,
  'technical-basics-pm': 3000,
  tpm: 18737,
  'tpm-intro': 16633,
  'user-insight': 2110,
};

module.exports = {
  CourseVisits,
};
